module.exports = __webpack_public_path__ + "static/media/rs-2.9f88cf5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/rs-2.png
// module id = 108
// module chunks = 0